import { TempSubmitData, } from "./requestedTurn.type";
import { useState } from "react";
import LavorisService from "../../../services/LavorisService";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import Textarea from "../../../components/others/Textarea/Textarea";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import SearchSelectFetch from "../../../components/others/SearchFetch";
import { PillButton } from "../../../components/others/PillButton";
import { Practice, } from "../../../services/TurnServices/Turns.type";
import { fetchAndFilterMoldes, fetchAndFilterPractices } from "./utils";
import { useSelector } from "react-redux";
import { SelectedFiles } from "../../../components/others/FileUploader/FileUploader.types";
import DynamicFileUpload from "../../../components/others/DynamicFileUpload";
import { RootState } from "../../../store/combineReducer";
import {
  ExamDetails,
  MoldeDetails,
  PracticesPillows,
} from "../AppointmentMetadata";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";

type TProps = {
  urlTittle: string;
  refreshFunction?: Function;
  patientType: string;
  isApplicant?: boolean;
};

export default function RequestTurnForm({
  urlTittle,
  refreshFunction,
  patientType,
  isApplicant
}: TProps) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    watch,
    resetField,
    setValue,
  } = useForm<TempSubmitData>({
    mode: "all",
  });

  const [molde, exam, practicesSelected] = watch([
    "molde",
    "exam",
    "practicesSelected",
  ]);
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;
  const { showAlert } = useAlert();
  //useStates
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [optionFailed, setOptionFailed] = useState(false);
  const { currentCompany, companies } = useSelector(
    (state: RootState) => state.user,
  );
  const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(
    null,
  );
  const patientId = searchParams.get("rowId") || "";
  const LavorisInstance = LavorisService.getInstance();

  // OnSubmit
  const onSubmit = async (data: TempSubmitData) => {
    const filesToUpload = selectedFiles?.profileImages ?? [];
    if (!filesToUpload.length) {
      showAlert("Para solicitar un turno, es obligatorio adjuntar el presupuesto.");
      return;
    }

    setLoading(true);
    try {
      const metadata = {
        exam: exam?.id,
        molde: molde?.id,
        practices: practicesSelected?.map((p) => p.id),
      };

      const partialSubmitData = {
        observations: data.comments,
        patientType: patientType,
        patientId,
        metadata,
      };

      const res = await LavorisInstance.TurnServices.RequestParticularCLientTurnService(partialSubmitData)

      if (res && filesToUpload.length) {
        await Promise.all(
          filesToUpload.map((file) => uploadFile(res.appointment, file)),
        );
      }
      refreshFunction?.()
    } catch (err) {
      showAlert(getErrorMessage({ title: 'No se pudo realizar la solicitud.', err }))
    } finally {
      setLoading(false);
    }
  };


  ///Funciones para la carga de archivos

  const updateUploadedFiles = (files: File[]) =>
    setSelectedFiles({ ...selectedFiles, profileImages: files });

  const uploadFile = async (id: string, selectedFile: File) => {
    await LavorisInstance.TurnServices.addFile(
      { file: selectedFile },
      id,
    ).catch((e: any) => console.log(e));
  };
  /******************************************************/


  return (
    <div className="max-w-3xl ">
      <form onSubmit={handleSubmit(onSubmit)}>
        {chosenRole !== 'RRHH_ABSENTEE' && (
          <>
            <div className="my-5">
              <SearchSelectFetch
                control={control}
                name="molde"
                label="Puestos (Exámenes sugeridos)"
                disabled={Boolean(exam)}
                fetchOptions={async () => {
                  return fetchAndFilterMoldes(
                    LavorisInstance,
                    currentCompany?.id || companies[0]?.id,
                    patientType,
                  );
                }}
                propertyLabel={"name"}
                inputStyles="rounded w-full h-[50px]"
              />
              {molde && (
                <div className="my-5">
                  <div className="mb-6">
                    <PillButton
                      text={molde.name || molde.position.name}
                      onClick={() => resetField("molde")}
                    />
                  </div>
                  <MoldeDetails molde={molde} />
                </div>
              )}
            </div>
            <SearchSelectFetch
              control={control}
              name="exam"
              label="Examen"
              fetchOptions={async () =>
                LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                  patientType,
                )
              }
              propertyLabel={"name"}
              inputStyles="rounded w-full h-[50px]"
              disabled={Boolean(molde)}
            />
            {exam && (
              <div className="mb-6">
                <div className="mb-6">
                  <PillButton
                    key={`exam-${exam.id}`}
                    text={exam.name}
                    onClick={() => resetField("exam")}
                  />
                </div>
                <ExamDetails exam={exam} />
              </div>
            )}

          </>)

        }



        <StyledWrapper.FormContainer>

          <SearchSelectFetch
            control={control}
            name="practiceSelector"
            label="Prácticas individuales"
            fetchOptions={async () => {
              return fetchAndFilterPractices(
                LavorisInstance,
                exam,
                molde,
                practicesSelected,
                patientType
              );
            }}
            propertyLabel={"name"}
            inputStyles="rounded w-full h-[50px]"
            onSelected={(data) => {
              const selected = practicesSelected?.length
                ? practicesSelected
                : [];
              setValue("practicesSelected", [...selected, data]);
            }}
          />
          {practicesSelected?.length >= 0 && (
            <PracticesPillows
              practices={practicesSelected}
              onClick={(practice: Practice) => {
                setValue(
                  "practicesSelected",
                  practicesSelected.filter((p) => p.id !== practice.id),
                );
              }}
            />
          )}
          <Textarea
            fieldName="comments"
            label="Comentarios"
            register={register}
            error={errors?.comments}
            styles="rounded w-full mb-4"
          />
          <p className="text-red-600 font-semibold mb-2">
            Para solicitar un turno, es obligatorio adjuntar el presupuesto.
          </p>
          <DynamicFileUpload
            label="Adjuntar archivo"
            updateFilesCb={updateUploadedFiles}
            maxFileSizeInBytes={10 * 1024 * 1024}
            accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls"
            multiple
            buttonText="Agregar otro archivo"
          />
        </StyledWrapper.FormContainer>
        <StyledWrapper.Footer>
          <div className="w-52">
            <PrimaryButton
              type="submit"
              text={optionFailed ? "Terminar de solicitar" : "Terminar de Confirmar Turno"}
              styles="bg-red-500 font-bold text-white mt-3"
              disabled={loading}
            />
          </div>
        </StyledWrapper.Footer>
      </form>
    </div>
  );
}
